import { AuthenticationModule, TransactionName } from './index'
import axios from 'axios'
import { TransactionHeaderName } from '@/store/modules/Transaction'
import { stepName as initialStepName } from '@/components/process/generic/Authentication/Login/RestrictedLogin/InputMsisdn'

const handleNonJsonError = function (error) {
  if (error.response && error.response.headers) {
    if (error.response.headers['content-type'] !== 'application/json') {
      error.response.data = 'Es trat ein Netzwerk-Fehler auf: ' + error.response.status
    }
  }
  throw error
}

const initialState = {
  step: initialStepName,
  authenticationToken: null,
  data: {
    msisdn: null,
    channel: null,
    birthdate: null,
    expiration: null,
    shortenedEmail: null
  },
  channelOptions: null
}

const RestrictedAuthenticationModule = {
  state: initialState,
  mutations: {
    ...AuthenticationModule.mutations,
    logout (state) {
      state.authenticationToken = null
      state.step = initialStepName
    },
    restrictedLoginMsisdn (state, msisdn = false) {
      if (msisdn !== false) state.data.msisdn = msisdn
    },
    restrictedLoginChannel (state, channel = false) {
      if (channel !== false) state.data.channel = channel
    },
    restrictedLoginChannelOptions (state, channelOptions) {
      state.channelOptions = channelOptions
    },
    resetRestrictedLogin (state) {
      Object.assign(state, initialState)
    },
    changeRestrictedLoginStep (state, { step }) {
      state.step = step
    },
    restrictedLoginRequestRequestData (state, { expiration, shortenedEmail }) {
      state.data.expiration = expiration
      state.data.shortenedEmail = shortenedEmail
    }
  },
  actions: {
    async login ({ commit, state, getters }, { msisdn, token, birthdate }) {
      try {
        commit('clearMessages', {}, { root: true })
        commit('Transaction/createTransactionId', TransactionName)
        const headers = {}
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]
        const response = await axios.post(getters.baseUrl + '/api/token', {
          grant_type: 'code',
          client_id: getters.clientId,
          client_secret: getters.clientSecret,
          msisdn,
          code: token.trim(),
          birthdate
        }, {
          headers
        })
        commit('authenticate', response.data)
        commit('Transaction/updateAccessTokenHash', TransactionName)
        commit('changeRestrictedLoginStep', { step: 'loggedIn' })
        return state.authenticationToken.accessToken
      } catch (error) {
        throw handleNonJsonError(error)
      }
    },
    logout: AuthenticationModule.actions.logout,
    updateAuthTokens: AuthenticationModule.actions.updateAuthTokens,
    removeAuthTokens: AuthenticationModule.actions.removeAuthTokens,
    setRestrictedLoginMsisdn ({ commit, state, getters }, { msisdn = false, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('Transaction/createTransactionId', TransactionName)
      if (state.data.msisdn !== msisdn) { // different msisdn requires new channel options
        commit('restrictedLoginChannelOptions', null)
      }
      commit('restrictedLoginMsisdn', msisdn)

      if (!state.channelOptions) {
        const headers = {}
        headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]

        axios.get(getters.baseUrl + '/api/login/options/' + msisdn, {
          headers
        }).then(response => {
          commit('restrictedLoginChannelOptions', response.data)
          commit('changeRestrictedLoginStep', { step: nextStep })
        }).catch(e => {
          commit('addError', 'Es ist ein technischer Fehler aufgetreten.', { root: true })
          commit('restrictedLoginChannelOptions', null)
        })
      } else {
        commit('changeRestrictedLoginStep', { step: nextStep })
      }
    },
    setRestrictedLoginChannel ({ commit, state, getters }, { channel = false, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('Transaction/createTransactionId', TransactionName)
      commit('restrictedLoginChannel', channel)

      const headers = {}
      headers[TransactionHeaderName] = getters['Transaction/transactionIds'][TransactionName]

      axios.post(getters.baseUrl + '/api/login/request', {
        msisdn: state.data.msisdn,
        option: state.data.channel
      }, {
        headers
      }).then(response => {
        commit('restrictedLoginRequestRequestData', {
          shortenedEmail: response.data.shortened_email,
          expiration: new Date(response.data.expiration)
        })
        commit('changeRestrictedLoginStep', { step: nextStep })
      }).catch(e => {
        commit('addError', 'Es ist ein technischer Fehler aufgetreten.', { root: true })
      })
    },
    reset ({ commit, state, getters }) {
      const rememberedMsisdn = state.data.msisdn
      commit('resetRestrictedLogin')
      commit('restrictedLoginMsisdn', rememberedMsisdn)
    }
  },
  getters: {
    isAuthenticated: AuthenticationModule.getters.isAuthenticated,
    accessToken: AuthenticationModule.getters.accessToken,
    refreshToken: AuthenticationModule.getters.refreshToken,
    currentRestrictedLoginStep (state) {
      return state.step
    },
    getRestrictedLoginData: (state) => {
      return state.data || { }
    },
    getRestrictedLoginMsisdn: (state) => {
      return state.data.msisdn || ''
    },
    getRestrictedLoginChannel: (state) => {
      return state.data.channel || ''
    },
    getRestrictedLoginBirthdate: (state) => {
      return state.data.birthdate || null
    },
    getRestrictedLoginChannelOptions: (state) => {
      return state.channelOptions
    }
  }
}

export {
  RestrictedAuthenticationModule
}
